import React from 'react'
import useGlobalTheme from '../../hooks/useGlobalTheme'

function Footer() {
	const theme = useGlobalTheme()
	const isLight = theme === 'light'
	const linkClass = isLight
		? 'text-gray-600 hover:text-gray-900 transition duration-300'
		: 'text-blue-200 hover:text-white transition duration-300'
	const linkClassSm = `${linkClass} text-sm`
	const dividerClass = isLight ? 'text-gray-400' : 'text-blue-200'
	const copyrightClass = isLight ? 'text-gray-500' : 'text-white'
	const socialClass = isLight
		? 'text-gray-500 hover:text-gray-900 transition duration-300'
		: 'text-blue-200 hover:text-white transition duration-300'
	return (
		<footer className={`py-6 sm:py-8 ${isLight ? 'bg-gray-50 border-t border-gray-200' : 'bg-[#00233b]'}`}>
			<div className="container mx-auto px-4">
				{/* Mobile Layout: Stacked vertically */}
				<div className="flex flex-col space-y-4 sm:hidden">
					{/* Links Section */}
					<div className="flex justify-center space-x-4">
						<a
							href="https://loadline.ai/policy"
							target="_blank"
							rel="noopener noreferrer"
							className={linkClassSm}
						>
							Privacy Policy
						</a>
						<span className={dividerClass}>|</span>
						<a
							href="https://loadline.ai/terms"
							target="_blank"
							rel="noopener noreferrer"
							className={linkClassSm}
						>
							Terms of Service
						</a>
					</div>

					{/* Copyright Section */}
					<div className={`${copyrightClass} text-center text-xs`}>
						Copyright © {new Date().getFullYear()} LoadLine | Leapcore Pte. Ltd.
						<br className="sm:hidden" />
						<span className="hidden sm:inline"> </span>All rights reserved.
					</div>

					{/* Social Media Section */}
					<div className="flex justify-center space-x-4">
						<a
							href="https://x.com/loadlineai"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-5 w-5 sm:h-6 sm:w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
							</svg>
						</a>

						<a
							href="https://www.instagram.com/loadline.ai/"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-5 w-5 sm:h-6 sm:w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
							</svg>
						</a>

						<a
							href="https://t.me/loadlineai"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-5 w-5 sm:h-6 sm:w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
							</svg>
						</a>
					</div>
				</div>

				{/* Desktop Layout: Horizontal */}
				<div className="hidden sm:flex justify-between items-center">
					{/* Links Section */}
					<div className="flex space-x-4">
						<a
							href="https://loadline.ai/policy"
							target="_blank"
							rel="noopener noreferrer"
							className={linkClass}
						>
							Privacy Policy
						</a>
						<span className={dividerClass}>|</span>
						<a
							href="https://loadline.ai/terms"
							target="_blank"
							rel="noopener noreferrer"
							className={linkClass}
						>
							Terms of Service
						</a>
					</div>

					{/* Copyright Section */}
					<div className={`${copyrightClass} text-center`}>
						Copyright © {new Date().getFullYear()} LoadLine | Leapcore Pte. Ltd. All rights reserved.
					</div>

					{/* Social Media Section */}
					<div className="flex space-x-4">
						<a
							href="https://x.com/loadlineai"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-6 w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
							</svg>
						</a>

						<a
							href="https://www.instagram.com/loadline.ai/"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-6 w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
							</svg>
						</a>

						<a
							href="https://t.me/loadlineai"
							target="_blank"
							rel="noopener noreferrer"
							className={socialClass}
						>
							<svg
								xmlns="http://www.w3.org/2000/svg"
								className="h-6 w-6"
								fill="currentColor"
								viewBox="0 0 24 24"
							>
								<path d="M11.944 0A12 12 0 0 0 0 12a12 12 0 0 0 12 12 12 12 0 0 0 12-12A12 12 0 0 0 12 0a12 12 0 0 0-.056 0zm4.962 7.224c.1-.002.321.023.465.14a.506.506 0 0 1 .171.325c.016.093.036.306.02.472-.18 1.898-.962 6.502-1.36 8.627-.168.9-.499 1.201-.82 1.23-.696.065-1.225-.46-1.9-.902-1.056-.693-1.653-1.124-2.678-1.8-1.185-.78-.417-1.21.258-1.91.177-.184 3.247-2.977 3.307-3.23.007-.032.014-.15-.056-.212s-.174-.041-.249-.024c-.106.024-1.793 1.14-5.061 3.345-.48.33-.913.49-1.302.48-.428-.008-1.252-.241-1.865-.44-.752-.245-1.349-.374-1.297-.789.027-.216.325-.437.893-.663 3.498-1.524 5.83-2.529 6.998-3.014 3.332-1.386 4.025-1.627 4.476-1.635z" />
							</svg>
						</a>
					</div>
				</div>
			</div>
		</footer>
	)
}

export default Footer
